import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BookingEventEmitters {
  public baseFinishedInitializingEvent = new EventEmitter();
  public openScheduledEventContextMenu = new EventEmitter();
  public dateChangeDateEvent = new EventEmitter();
  public updateBookingEvent = new EventEmitter();
  public cancelBookingEvent = new EventEmitter();
  public additionalPaymentRequiredEvent = new EventEmitter();
  public updateScheduledBookingEvent = new EventEmitter();
}